import { fontStyleClass } from "../../utils";

export const commonStyle = {
  ...fontStyleClass,
};
